import { IMessagingService } from "../services";
import { hide, show } from "../utils";

abstract class Container {

    // this is the html element id
    public containerId: string;
    public containerEl: HTMLElement;

    constructor(containerEl: HTMLElement, protected messagingService: IMessagingService) {
        this.containerEl = containerEl;
        this.containerId = containerEl.id;
    }

    show() {
        show(this.containerEl);
    }

    hide() {
        hide(this.containerEl);
    }

    enable() {
    }

    disable() {
    }
}

export { Container }